export namespace DailyRepoStates {
    export function dailyRepoPrintStatesFactory() {
        const printerOb: any = {
            timestamp: new Date(),
            next: ''
        };
        return printerOb;
    }

    export function dailyReportStates() {
        const dailyReport: any = {
            isFetching: false
        };
        return dailyReport;
    }

    export function mutations() {
        return {
            dailyReportStartFetching(state: any) {
                state.dailyReport.isFetching = true;
            },
            dailyReportEndFetching(state: any) {
                state.dailyReport.isFetching = false;
            },
            print(state: any, nextToPrint: any) {
                state.printerOb.timestamp = new Date();
                state.printerOb.next = nextToPrint;
            },
        };
    }
}

